import {
  afterRenderEffect,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  effect,
  inject,
  Input,
  OnInit,
  ChangeDetectorRef, PLATFORM_ID
} from '@angular/core';
import {
  IonButton,
  IonCol, IonFab, IonFabButton,
  IonIcon,
  IonImg,
  IonInput,
  IonItem, IonLabel, IonList,
  IonRow, IonSegment, IonSegmentButton,
} from "@ionic/angular/standalone";
import {RouterLink} from "@angular/router";
import {DatePipe, isPlatformBrowser} from "@angular/common";
import {CommonService, Subscriber} from "../../core/common.service";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {smLinks} from "../../configs/content/sm-links";
import {components} from '../../configs/config';
import {LanguageService} from '../../core/language.service';
import {ChatWindowComponent} from '../chat-window/chat-window.component';
import {PageService} from '../../pages/page.service';
import {TranslateModule} from '@ngx-translate/core';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
  imports: [
    IonIcon,
    IonRow,
    IonCol,
    IonImg,
    IonInput,
    IonButton,
    IonItem,
    IonLabel,
    RouterLink,
    DatePipe,
    ReactiveFormsModule,
    IonList,
    IonSegment,
    IonSegmentButton,
    ChatWindowComponent,
    IonFab,
    IonFabButton,
    TranslateModule
  ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FooterComponent  implements OnInit {

  @Input() showChat: boolean = false;
  date = new Date();
  subscribeForm = new FormGroup({
    type: new FormControl('b2c'),
    email: new FormControl(null, [Validators.required, Validators.email]),
  });
  isSuccess: boolean = false;
  isError: boolean =false;
  message: string = '';
  isSaving: boolean = false;
  navigationContent: any;
  commonService: CommonService = inject(CommonService);
  languageService: LanguageService = inject(LanguageService);
  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);
  constructor(private cdr: ChangeDetectorRef) {
    effect(async () => {
      if (this.languageService.lang()) {
        this.navigationContent = await this.languageService.loadContent(components.navigation);
        this.cdr.detectChanges();
      }
    });
  }

  async ngOnInit() {
    this.navigationContent = await this.languageService.loadContent(components.navigation);
    if (this.isBrowser)
    if (localStorage.getItem('cookiesAccept')) {
      this.hideCookies = false;
      this.cdr.detectChanges();
    }
  }

  pageService: PageService = inject(PageService);
  pageContent = computed(() => this.pageService.pageContentResource.value()?.content);
  isContentLoading = this.pageService.pageContentResource.isLoading;
  isSubmit: boolean = false;
  async subscribe() {
    if (!this.subscribeForm.value.email) {
      this.isError = true;
      this.message = 'Enter email address';
      setTimeout(() => {
        this.isError = false;
        this.message = '';
      }, 3000);
      return;
    }
    if (this.isSubmit) {
      return;
    }
    this.isSubmit = true;
    this.isError = false;
    this.isSaving = true;
    try {
      const data: Subscriber = { email: this.subscribeForm.value.email, type: this.subscribeForm.value.type };
      const success = await this.commonService.saveUser(data);
      this.isSuccess = true;
      this.message = 'Thank you for subscribing';
      this.subscribeForm.reset();
      this.isSaving = false;
      this.isSubmit = false;
    } catch (e) {
      this.isError = true;
      this.isSaving = false;
      this.isSubmit = false;
    }
    setTimeout(() => {
      this.message = '';
      this.isError = false;
      this.isSuccess = false;
    }, 3000);
  }

    protected readonly smLinks = smLinks;

  hideCookies: boolean = true;
  acceptCookies() {
    this.hideCookies = false;
    localStorage.setItem('cookiesAccept', '1');
  }

  rejectCookies() {
    //
    this.hideCookies = false;
  }
}
